import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";

const columns = [
  {
    title: "No. Anggota",
    dataIndex: "noAnggota",
    key: "noAnggota",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "No. Simp",
    dataIndex: "noSimpanan",
    key: "noSimpanan",
  },
  {
    title: "Nama",
    dataIndex: "nameAnggota",
    key: "nameAnggota",
  },
  {
    title: "Tgl Masuk Anggota",
    dataIndex: "tglMasuk",
    key: "tglMasuk",
  },
  {
    title: "Alamat",
    dataIndex: "alamat",
    key: "alamat",
  },
  {
    title: "NOPOL",
    dataIndex: "nopol",
    key: "nopol",
    render: (text) => <p>{text ? text : "-"}</p>,
  },
  {
    title: "ANG. AKTIF",
    dataIndex: "isActive",
    key: "isActive",
    render: (text, record) => (
      <strong>{record.isActive ? "AKTIF" : "NON AKTIF"}</strong>
    ),
  },
  {
    title: "Keterangan",
    dataIndex: "keterangan",
    key: "keterangan",
  },
  {
    title: "Simp. Pokok",
    dataIndex: "simpananPokok",
    key: "simpananPokok",
    render: (text) => <p>{formatRupiah(text)}</p>,
  },
  {
    title: "Simp. Wajib",
    dataIndex: "simpananWajib",
    key: "simpananWajib",
    render: (text) => <p>{formatRupiah(text)}</p>,
  },
];

const formValidation = [
  [
    {
      title: "No. Anggota",
      key: "noAnggota",
      placeholder: "Masukan No. Anggota",
      type: "text",
      required: true,
      validationText: "nomor anggota harus diisi!",
    },
    {
      title: "No Simpanan",
      key: "noSimpanan",
      placeholder: "Masukan No. Simpanan",
      type: "text",
      required: true,
      validationText: "nomor simpanan harus diisi!",
    },
  ],
  {
    title: "Tanggal Masuk",
    key: "tglMasuk",
    placeholder: "Masukan tanggal masuk Anggota",
    type: "dateTime",
    required: true,
    validationText: "tanggal masuk harus diisi!",
  },
  {
    title: "Nama Anggota",
    key: "nameAnggota",
    placeholder: "Masukan Nama Anggota",
    type: "text",
    required: true,
    validationText: "nama anggota harus diisi!",
  },
  // {
  //   title: "Tanggal Masuk",
  //   key: "tglMasuk",
  //   placeholder: "Masukan tanggal masuk Anggota",
  //   type: "dateTime",
  //   required: true,
  //   validationText: "tanggal masuk harus diisi!",
  // },
  {
    title: "Alamat",
    key: "alamat",
    placeholder: "Masukan Alamat",
    type: "textarea",
    required: true,
    validationText: "alamat harus diisi!",
  },
  {
    title: "Anggota Aktif",
    key: "isActive",
    type: "radio",
    required: true,
    options: [
      { label: "Aktif", value: true },
      { label: "Non Aktif", value: false },
    ],
    // placeholder: "Masukan isActive",
    // validationText: "isActive, harus diisi!",
  },
  {
    title: "Keterangan",
    key: "keterangan",
    placeholder: "Masukan Keterangan",
    type: "text",
    // required: true,
    // validationText: "Keterangan harus diisi!",
  },
  [
    {
      title: "Nopol",
      key: "nopol",
      placeholder: "Masukan Nopol",
      type: "text",
      required: true,
      validationText: "nopol harus diisi!",
    },

    {
      title: "Simpanan Pokok",
      key: "simpananPokok",
      placeholder: "Masukan simpanan pokok",
      type: "number",
      required: true,
      validationText: "simpanan pokok harus diisi!",
    },
    {
      title: "Simpanan Wajib",
      key: "simpananWajib",
      placeholder: "Masukan simpanan wajib",
      type: "number",
      required: true,
      validationText: "simpanan wajib harus diisi!",
    },
  ],
];

export { columns, formValidation };
